import { AppRouteRecordRaw } from '@/router/types'

export const faceSignManage: AppRouteRecordRaw[] = [
  {
    path: 'faceSignManage',
    name: 'FaceSignManage',
    component: () => import('@/views/faceSignManage/index.vue'),
    meta: {
      title: 'AI智能视频面签管理'
    }
  }
]
